var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWall = function SvgWall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M11 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1ZM3.335 8V4h5.333v4H3.334ZM.667 8V4h2v4h-2Zm8.667-4h2v4h-2V4ZM11 .667a.333.333 0 0 1 .333.333v2.333h-5V.667H11Zm-10 0h4.666v2.666h-5V1A.333.333 0 0 1 1 .667Zm0 10.666A.333.333 0 0 1 .666 11V8.667h5v2.666H1Zm10 0H6.333V8.667h5V11a.333.333 0 0 1-.333.333Z"
  })));
};
export default SvgWall;